import { css } from "@emotion/react";
import { parseISO } from "date-fns";
import { useEffect, useState } from "react";
import { FindDialogsOutput } from "../use-omnichannel";
import Dialog from "./dialog";
import InfiniteScroll from "../../components/inifinite-scroll";

export interface DialogsProps {
  hasRequest: boolean;
  dialog?: { id: number };
  dialogs: FindDialogsOutput[];
  fetchMoreDialogs: () => void;
  onDialogClick: (id: number) => void;
  onDialogContextMenu?: (
    event: React.MouseEvent<HTMLDivElement>,
    id: number
  ) => void;
}

const Dialogs = ({
  hasRequest,
  dialog,
  dialogs,
  fetchMoreDialogs,
  onDialogClick,
  onDialogContextMenu
}: DialogsProps) => {
  const [selected, setSelected] = useState(-1);

  useEffect(() => {
    if (dialog) {
      setSelected(dialog.id);
    }
  }, [dialog]);

  return (
    <InfiniteScroll hasRequest={hasRequest} emitFetch={fetchMoreDialogs}>
      {dialogs.map((d) => (
        <Dialog
          css={css`
            background-color: ${d.id === selected ? "#282d35" : "#2f343d"};
          `}
          key={d.id}
          name={d.name}
          lastMessage={d.lastMessage}
          lastMessageDateTime={parseISO(d.lastMessageDateTime)}
          unreadMessageTotal={d.unreadMessageTotal}
          platform={d.plataform}
          avatarUrl={d.avatarUrl}
          fixed={Boolean(d.fixedAt)}
          onClick={() => {
            setSelected(d.id);
            onDialogClick(d.id);
          }}
          onContextMenu={
            onDialogContextMenu
              ? (event) => onDialogContextMenu(event, d.id)
              : undefined
          }
        />
      ))}
    </InfiniteScroll>
  );
};

export default Dialogs;
